import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';

class AdminAccountingPayoutPaymentRoute extends Route {
  /**
   * Register services
   */
  @service('states/routes/admin/accounting/payout/sh-payment') state;
  @service('state-managers/routes/admin/accounting/payout/sh-payment') stateManager;
  @service store;

  /** @inheritDoc */
  deactivate() {
    super.deactivate(...arguments);
    this.store.unloadAll('application');
  }

  /**
   *
   * @param params
   * @returns {*|Promise}
   */
  model(params) {
    return this.stateManager.loadShPayment(params.shPaymentId);
  }
}

export default AdminAccountingPayoutPaymentRoute;
